/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Not_Found_TitleInputs */

const en_project_not_found_title = /** @type {(inputs: Project_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work not found`)
};

const lv_project_not_found_title = /** @type {(inputs: Project_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darbs nav atrasts`)
};

/**
* | output |
* | --- |
* | "Work not found" |
*
* @param {Project_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_not_found_title = /** @type {((inputs?: Project_Not_Found_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Not_Found_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_not_found_title(inputs)
	return en_project_not_found_title(inputs)
});